import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Address from './Address/Address';
import BankAccounts from './BankAccounts/BankAccounts';
import CreditCards from './CreditCards/CreditCards';
import DriverLicense from './DriverLicense/DriverLicense';
import EmailAddresses from './EmailAddresses/EmailAddresses';
import MedicalIds from './MedicalIds/MedicalIds';
import Ibans from './Ibans/Ibans';
import PassportNumber from './PassportNumber/PassportNumber';
import TelephoneNumbers from './TelephoneNumbers/TelephoneNumbers';
import DarkWebModal from './DarkWebModal/DarkWebModal';
import Spinner from '../../../../CommonComponents/Spinner';
import { Message } from '../Monitoring/MonitoringStyles';
import { darkWebDataSelector } from '../../ReportsSelector';
import { isFetchingDarkWebDataSelector } from '../../../ExperianSelector';
import { StyledLinkButton } from './DarkWebStyles';
import { LABELS_DICT } from './DarkWebConstants';

const DarkWeb = () => {
  const [showModal, setShowModal] = useState(false);

  const data = useSelector(darkWebDataSelector);
  const isFetchingDarkWebData = useSelector(isFetchingDarkWebDataSelector);

  if (!data) {
    return <Message>There is currently no data being tracked</Message>;
  }

  return (
    <>
      {isFetchingDarkWebData && <Spinner />}
      {!!data &&
        Object.keys(data).map(key => (
          <div key={key}>
            {(() => {
              const title = LABELS_DICT[key];
              const itemData = data[key];
              switch (key) {
                case 'Address':
                  return <Address title={title} data={itemData} />;
                case 'BankAccounts':
                  return <BankAccounts title={title} data={itemData} />;
                case 'CreditCards':
                  return <CreditCards title={title} data={itemData} />;
                case 'EmailAddresses':
                  return <EmailAddresses title={title} data={itemData} />;
                case 'MedicalIds':
                  return <MedicalIds title={title} data={itemData} />;
                case 'IBANs':
                  return <Ibans title={title} data={itemData} />;
                case 'PassportNumber':
                  return <PassportNumber title={title} data={itemData} />;
                case 'TelephoneNumbers':
                  return <TelephoneNumbers title={title} data={itemData} />;
                case 'DriverLicense':
                  return <DriverLicense title={title} data={itemData} />;
                default:
                  return null;
              }
            })()}
          </div>
        ))}
      <StyledLinkButton prependIcon="fas fa-plus-circle" onClick={() => setShowModal(!showModal)}>
        Monitor Additional Information
      </StyledLinkButton>
      <DarkWebModal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        hasDriverLicense={!!(data.DriverLicense && data.DriverLicense.length > 0)}
        hasPassportNumber={!!(data.PassportNumber && data.PassportNumber.length > 0)}
      />
    </>
  );
};

export default DarkWeb;
